import { useMutation } from '@tanstack/react-query';
import {
  exportTableData,
  exportChartData,
  importAutoData,
  exportFile,
  importManualData,
} from '../requests/docs';

const KEY = 'company';

const docsMutation = {
  useImportManual: () => useMutation({
    mutationKey: [KEY, 'import', 'manual'],
    mutationFn: (data) => importManualData(data),
  }),
  useExportTable: () => useMutation({
    mutationKey: [KEY, 'export', 'table'],
    mutationFn: (data) => exportTableData(data),
  }),
  useExportChart: () => useMutation({
    mutationKey: [KEY, 'export', 'chart'],
    mutationFn: (data) => exportChartData(data),
  }),
  useExportFile: () => useMutation({
    mutationKey: [KEY, 'export', 'file'],
    mutationFn: (data) => exportFile(data),
  }),
  useImportAuto: () => useMutation({
    mutationKey: [KEY, 'import', 'auto'],
    mutationFn: (data) => importAutoData(data),
  }),
};

export default docsMutation;
